import { CollectionHero, HubTiles } from "@/components/CollectionHero";
import { FLOORING_HUB } from "@/lib/timber";

export default function FlooringHub() {
  return (
    <div data-testid="flooring-hub">
      <CollectionHero
        crumbs={[
          { label: "Our Collection", to: "/collection" },
          { label: "Timber Collection", to: "/collections/timber" },
          { label: "Timber Flooring" },
        ]}
        eyebrow={FLOORING_HUB.eyebrow}
        title={FLOORING_HUB.title}
        intro={FLOORING_HUB.intro}
        heroSlides={FLOORING_HUB.heroSlides}
      />
      <HubTiles items={FLOORING_HUB.categories} columns="md:grid-cols-3" />
    </div>
  );
}
